import { env } from "@/lib/env";

// Agent Types - unified constant for both dropdowns and value comparisons
export const UC_CANDIDATE_OUTREACH = "CANDIDATE_OUTREACH" as const;
export const UC_TPMO = "TPMO" as const;
export const AGENT_TYPE = [UC_CANDIDATE_OUTREACH, UC_TPMO] as const;

// Agent Type Labels for display
export const AGENT_TYPE_LABELS = {
  [UC_CANDIDATE_OUTREACH]: "Candidate Outreach",
  [UC_TPMO]: "TPMO",
} as const;


// Transaction Types for Failure Transactions
export const TRANSACTION_TYPES = [
  "CO_CANDIDATE_MESSAGE",
  "CO_CANDIDATE_OUTREACH",
  "CO_JOB_DETAIL",
  "TPMO_WORK_ORDER",
  "IM_PUBLISH",
  "EMAIL_PUBLISH"
] as const;

// Transaction Status for Failure Transactions
export const TRANSACTION_STATUS = [
  "PENDING",
  "PROCESSING",
  "COMPLETED",
  "FAILED_FINAL"
] as const;

// Authentication & Storage Keys
export const STORAGE_KEYS = {
  BACKEND_JWT: "backend_jwt",
  AUTH0_RAW_TOKEN: "auth0_raw_token",
  USER_PROFILE: "user_profile",
  ACCESS_TOKEN: "access_token",
} as const;

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: env.DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_STRING: "1",
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
} as const;

// HTTP Methods
export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
} as const;

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

// URL Parameters
export const URL_PARAMS = {
  TYPE: "type",
  NAME: "name",
  PAGE: "page",
  ID: "id",
} as const;

// Table Search Keys
export const SEARCH_KEYS = {
  NAME: "name",
  TYPE: "type",
} as const;

// JWT Configuration
export const JWT_CONFIG = {
  DEFAULT_SKEW_SECONDS: 30,
  TOKEN_SEPARATOR: ".",
  BASE64_REPLACEMENTS: {
    DASH: "+",
    UNDERSCORE: "/",
  },
} as const;

// Page Titles
export const PAGE_TITLES = {
  HOME: "Home",
  SUPPLEMENT_DATA: "Master Data",
  CAMPAIGN_MANAGEMENT: "Campaign Management",
  CREATE_CAMPAIGN: "Create Campaign",
  VIEW_UPDATE_CAMPAIGN: "View And Update Campaign",
  WEBCHAT: "Web Chat",
} as const;

// Business Data Types
export const SUPPLEMENT_TYPES: readonly string[] = [
  "Recipient Persona",
  "Language"
] as const;

// Define the type for supplement additional attributes
export interface SupplementAdditionalAttribute {
  key: string;
  label: string;
  value: string;
  type: string;
  mandatory: boolean;
}

export const SUPPLEMENT_ADDITIONAL_ATTR: SupplementAdditionalAttribute[] = [];


// Regex Patterns
export const REGEX_PATTERNS = {
  NUMERIC_ID: /^\d+$/,
  CONTENT_RANGE: /\/(\d+)$/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^\+[1-9][\d-]{1,14}$/,
} as const;

// Default Values (non-environment specific)
export const DEFAULTS = {
  RADIX: 10,
  ARRAY_LENGTH_3: 3,
  ARRAY_LENGTH_5: 5,
  MAX_FOLLOWUPS: 10,
} as const;

// Question Types and Confidence Scores
export const QUESTION_TYPES = {
  MANDATORY: "MANDATORY",
  PREFERRED: "PREFERRED",
  OPTIONAL: "OPTIONAL",
  GENERAL: "GENERAL",
} as const;

export const CONFIDENCE_SCORES = {
  [QUESTION_TYPES.MANDATORY]: 1,
  [QUESTION_TYPES.PREFERRED]: 0.8,
  [QUESTION_TYPES.OPTIONAL]: 0.7,
  [QUESTION_TYPES.GENERAL]: 0.5,
} as const;

export const QUESTION_TYPE_OPTIONS = [
  { value: QUESTION_TYPES.MANDATORY, label: "MANDATORY" },
  { value: QUESTION_TYPES.PREFERRED, label: "PREFERRED" },
  { value: QUESTION_TYPES.OPTIONAL, label: "OPTIONAL" },
  { value: QUESTION_TYPES.GENERAL, label: "GENERAL" },
] as const;

// Form Validation Constants
export const FORM_VALIDATION = {
  MAX_CAMPAIGN_TYPE_LENGTH: 100,
  MAX_CAMPAIGN_NAME_LENGTH: 1000,
  MIN_MAX_FOLLOWUPS: 1,
  MAX_MAX_FOLLOWUPS: 100,
} as const;

// Sender Persona Greeting Placeholders
export const GREETING_PLACEHOLDERS = [
  "{recipient_name}",
  "{from_email_name}",
] as const;

export const DEFAULT_GREETING = "Hi {recipient_name},\nThis is {from_email_name} from Service Global.";

export type GreetingPlaceholder = typeof GREETING_PLACEHOLDERS[number];
